import { render, staticRenderFns } from "./InactivityWarningDialog.vue?vue&type=template&id=4fd10e5c&scoped=true&"
import script from "./InactivityWarningDialog.vue?vue&type=script&lang=js&"
export * from "./InactivityWarningDialog.vue?vue&type=script&lang=js&"
import style0 from "./InactivityWarningDialog.vue?vue&type=style&index=0&id=4fd10e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd10e5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
